import { type MRT_ColumnDef } from 'mantine-react-table';
import moment from 'moment';
import React, { useMemo } from 'react';
import { CustomChip } from '../../../../../layout/styledcomponents/CustomChip';
import GenericTable from '../../../../shared/GenericTable';
import { trackEvent } from '../../../../../app/Analytics';

export default function GuestCompanies(params: any) {
    const processedData = useMemo(() => {
        if (!params.data) return [];
        return params.data.map((row: any) => ({
            ...row,
            createdDate: new Date(
                new Date(row.createdDate).setHours(0, 0, 0, 0),
            ),
        }));
    }, [params.data]);

    const columns: MRT_ColumnDef<any>[] = [
        {
            accessorKey: 'name',
            header: 'Company',
            mantineTableHeadCellProps: {
                title: 'Companies who have submitted a boking (all statuses)',
            },
        },
        {
            accessorKey: 'primaryContact',
            header: 'Contact',
        },
        {
            accessorKey: 'phone',
            header: 'Phone',
        },

        {
            accessorKey: 'createdDate',
            header: 'Member Since',
            filterVariant: 'date',
            filterFn: 'equals',
            sortingFn: 'datetime',
            mantineTableHeadCellProps: {
                title: 'Member of 7DAY since date',
            },
            mantineFilterDateInputProps: {
                valueFormat: 'DD/MM/YYYY',
            },
            Cell: ({ row, cell }) =>
                moment(row.original?.createdDate).format('DD/MM/YYYY'),
        },
        {
            accessorKey: 'activeUsers',
            header: 'Current Users',
            mantineTableHeadCellProps: {
                title: 'No. of current users on 7DAY belonging to company',
            },
        },
        {
            accessorKey: 'bookings',
            header: 'No. Reservations',
            mantineTableHeadCellProps: {
                title: 'No. of Reservations made by guest company',
            },
        },
        {
            accessorKey: 'isActive',
            id: 'isActive',
            header: 'Status',
            filterVariant: 'select',
            filterFn: (row, _columnId, filterValue) => {
                if (filterValue === '') return true;
                return String(row.getValue('isActive')) === filterValue;
            },

            mantineFilterSelectProps: {
                data: [
                    { label: 'Enabled', value: 'true' },
                    { label: 'Disabled', value: 'false' },
                ],
                clearable: true,
            },
            mantineTableHeadCellProps: {
                title: 'Company Membership Status',
            },
            Cell: ({ row, cell }) => {
                const status = cell.getValue();

                return (
                    <CustomChip
                        label={status === true ? 'Enabled' : 'Disabled'}
                        color={status === true ? 'green' : 'red'}
                        variant='outlined'
                    />
                );
            },
        },
    ];

    return (
        <GenericTable
            columns={columns}
            data={processedData}
            tableName='7DAY-Guest-Details-Report'
            loading={!params.data}
            onRowClick={() => {
                trackEvent(
                    'Reports',
                    'Guest Details Report Clicked',
                    'Guest Details Report Clicked',
                );
            }}
        />
    );
}
